import AuthToken from './AuthToken'

const authToken = new AuthToken().init()

export { authToken }
